const Ribbon = () => {
    return (
        <div>
        <svg
              xmlns="http://www.w3.org/2000/svg"
              width="231"
              height="32"
              viewBox="0 0 231 32"
            >
              <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
                <g transform="translate(-55 -1160)">
                  <g transform="translate(20 1033)">
                    <g transform="translate(35 127)">
                      <path
                        fill="#2EA9BE"
                        d="M0 0L134.220967 0 203 0 203 32 0 32z"
                      ></path>
                      <path
                        fill="#2EA9BE"
                        d="M203 0h23.592a2 2 0 011.506 3.317L217 16l-14 16V0z"
                      ></path>
                      <path
                        fill="#2EA9BE"
                        d="M203 0h23.592a2 2 0 011.506 3.317L217 16l-14 16V0z"
                        transform="matrix(1 0 0 -1 0 32)"
                      ></path>
                      <path
                        fill="#FFF"
                        fillRule="nonzero"
                        d="M48.19 8.656c-.022-.149-.248-1.035.146-.956.181-.149-.235-.418-.357-.509-.063-.047-.22-.175-.293-.187-.15-.026-.155.08-.21.198-.116.255-.116.482-.116.754 0 .28-.014.564-.014.834 0 .347.061.651-.018.994-.133.577-.519 1.058-.968 1.45-.333.29-.676.305-1.085.142-.501-.198-.848-.558-1.216-.918-.356-.347-.776-.69-1.225-.917a2.694 2.694 0 00-.995-.309c-.624-.06-1.243-.032-1.823.226a3.974 3.974 0 00-1.031.67c-.308.271-.647 0-.98-.156-.412-.194-1.162-.069-1.485.278-.159.161-.302.337-.428.524-3.1-1.197-6.42-.545-8.772 2.143-.317.362-.626.772-.912 1.166-.571.787-.88 1.75-1.286 2.622-.332.715-.738 1.452-1.026 2.173-.05.124-.138.312-.073.443.08.163.273.143.381.018.147-.18.265-.38.35-.595.128-.304.29-.667.426-.98.045-.102.2-.432.245-.55 0 .103.015.279.016.383 0 .265.04.526.07.79.028.264.052.55.117.812.088.352.169.722.311 1.056.23.54.519 1.052.864 1.528.197.267.415.518.652.75.212.21.4.37.709.429.25.055.512.05.76-.014.327-.091.43-.322.582-.604.122-.227.283-.417.425-.635.265-.405.572-.794.968-1.086.668-.496 1.31-.602 2.116-.613.283-.007.566.042.83.144.363.137.699.334.993.584.351.308.622.69.878 1.076.192.29.346.612.578.875.233.264.466.283.814.283.444 0 .751 0 1.057-.36.582-.68 1.06-1.327 1.424-2.142.263-.588.38-1.253.425-1.89.032-.446.066-.83.05-1.244-.15.297-.432.523-.715.694-.335.2-.648.24-1.039.246-.93.014-1.743-.503-2.288-1.223a4.365 4.365 0 01-.642-1.217 4.602 4.602 0 01-.241-1.466c.006-.25.008-.674.131-.907.18-.338.213.266.233.397.054.352.115.705.232 1.042.167.485.363.97.679 1.403.324.446.755.886 1.277 1.1.441.177.93.203 1.387.074.235-.063.45-.183.629-.347.153-.145.428-.366.504-.558.009-.021.582.214.652.235.464.134.958.148 1.437.099.492-.053.974-.17 1.435-.35.207-.08.395-.192.606-.262.15-.05.396-.12.49-.261.157-.237-.18-.474-.313-.66-.16-.226-.219-.478-.36-.716.101.168.487.158.652.164.309.01.563-.106.848-.215.134-.058.26-.132.377-.22.238-.175.462-.37.668-.58a5.63 5.63 0 00.625-.73c.237-.348.44-.718.605-1.104.243-.55.366-1.108.425-1.703.056-.56-.092-1.078-.169-1.615z"
                      ></path>
                      <text
                        fill="#FFF"
                        fontFamily="Gotham-Medium, Gotham"
                        fontSize="12.5"
                        fontWeight="400"
                        letterSpacing="0.292"
                      >
                        <tspan x="57" y="19">
                          M+A Buying Guide
                        </tspan>
                      </text>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
        </div>
    )
}

export default Ribbon
